import React, { useState, useEffect } from 'react'
import { analytics } from '@pmi/pmi-iqos-shared-react'
import { ProductCardGeneric } from '@zyn-common/components'

const CardSubscription = ({
  product,
  productPosition,
  mainCategoryName,
  onViewPlanDetails,
  translations
}) => {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(
    product.options ? product.selectedOptionIndex || 0 : null
  )
  const { options } = product
  const { images, description } = options[selectedOptionIndex]
  const bazaarVoice = product ? product.bv : null
  const bazaarVoiceProductId = options
    ? options[selectedOptionIndex].bv_id
    : bazaarVoice
    ? bazaarVoice.bv_id
    : null
  const bazaarVoiceShowRating =
    bazaarVoice && bazaarVoice.display_rating === true && bazaarVoiceProductId

  useEffect(() => {
    if (
      product &&
      product.selectedOptionIndex !== undefined &&
      product.selectedOptionIndex !== selectedOptionIndex
    ) {
      setSelectedOptionIndex(product.selectedOptionIndex)
    }
  }, [product])

  const handleChangeColor = optionIndex => {
    if (selectedOptionIndex !== optionIndex) {
      setSelectedOptionIndex(optionIndex)
      analytics.productImpression(
        product,
        selectedOptionIndex,
        productPosition,
        mainCategoryName
      )
    }
  }

  const handleOnCardClick = () => {
    analytics.productClick(
      product,
      selectedOptionIndex,
      productPosition,
      mainCategoryName
    )
  }

  const handleViewPlanDetails = async () => {
    if (selectedOptionIndex !== null && selectedOptionIndex !== undefined) {
      onViewPlanDetails && onViewPlanDetails(product, selectedOptionIndex)
    }
    analytics.viewPlanDetails(product, selectedOptionIndex)
  }

  return (
    <ProductCardGeneric
      hasBadge
      href={product.productUrl}
      handleOnCardClick={handleOnCardClick}
      handleChangeColor={handleChangeColor}
      selectedOptionIndex={selectedOptionIndex}
      translations={translations}
      title={product.title}
      description={description}
      price={product.subscriptionPriceStr}
      images={images}
      options={options}
      testingPrefix="SubscriptionProductList"
      bazaarVoiceProductId={bazaarVoiceShowRating ? bazaarVoiceProductId : null}
      buttonViewPlanDetailsLabel={translations.tk_buttonViewPlanDetails}
      isSubscription={true}
      handleViewPlanDetails={handleViewPlanDetails}
    />
  )
}

export default CardSubscription
